function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { initialUpdate, update } from '@engine/actions/creators/merchant-wpf-themes';
import Error from '@engine/components/presentational/base/error';
import Icon from '@engine/components/presentational/base/icon';
import React from 'react';
import Spinner from '@engine/components/presentational/base/spinner';
import { connect } from 'react-redux';

var MerchantWpfThemes = /*#__PURE__*/function (_React$Component) {
  _inherits(MerchantWpfThemes, _React$Component);

  var _super = _createSuper(MerchantWpfThemes);

  function MerchantWpfThemes(props) {
    var _this;

    _classCallCheck(this, MerchantWpfThemes);

    _this = _super.call(this, props);
    _this.state = {
      updateToTheme: null
    };
    return _this;
  }

  _createClass(MerchantWpfThemes, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.initialUpdate({
        theme: this.props.initialTheme
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.props.isUpdating ? 'theme-wrapper-loading' : null
      }, this.props.themes.map(function (theme) {
        return React.createElement("div", {
          key: theme,
          className: _this2.className(theme)
        }, React.createElement("div", {
          className: "theme-img",
          onClick: function onClick() {
            return _this2.updateTheme(theme);
          }
        }), React.createElement("div", {
          className: "theme-name"
        }, theme.replace(/^\w/, function (firstLetter) {
          return firstLetter.toUpperCase();
        }), _this2.props.defaultTheme === theme && React.createElement("span", {
          className: "theme-default"
        }, "\xA0", _this2.props.defaultThemeText), _this2.props.customTheme === theme && React.createElement(React.Fragment, null, "\xA0", React.createElement("a", {
          href: _this2.props.customThemeUrl,
          className: "btn btn-xs btn-primary"
        }, React.createElement(Icon, {
          icon: "pencil"
        })))), _this2.showSpinner(theme) && React.createElement("div", {
          className: "theme-loader"
        }, React.createElement(Spinner, {
          position: "center",
          color: "refined-blue"
        })));
      }), this.props.hasError && React.createElement(Error, null, React.createElement(Icon, {
        icon: "exclamation-sign"
      }), React.createElement("b", null, this.props.updateFailedText), " ", this.props.errorMessageText));
    }
  }, {
    key: "className",
    value: function className(theme) {
      var classes = ['theme', "theme-".concat(theme)];

      if (this.props.theme === theme) {
        classes.push('theme-saved');
      }

      if (this.showSpinner(theme)) {
        classes.push('theme-loading');
      }

      return classes.join(' ');
    }
  }, {
    key: "showSpinner",
    value: function showSpinner(theme) {
      return this.props.isUpdating && this.state.updateToTheme === theme;
    }
  }, {
    key: "updateTheme",
    value: function updateTheme(theme) {
      if (this.props.theme === theme) {
        return;
      }

      this.setState({
        updateToTheme: theme
      });
      this.props.update(this.props.url, {
        wpf_theme: theme
      });
    }
  }]);

  return MerchantWpfThemes;
}(React.Component);

export default connect(function (state) {
  return {
    hasError: state.merchantWpfThemes.hasError,
    isUpdating: state.merchantWpfThemes.isUpdating,
    theme: state.merchantWpfThemes.theme
  };
}, {
  initialUpdate: initialUpdate,
  update: update
})(MerchantWpfThemes);